var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    transform: "translate(934 292)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-934 -292)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(938.569 292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9,30.155a3.269,3.269,0,0,1-1.334,2.778,5.574,5.574,0,0,1-3.235.877L26.5,29.241h5.483A.914.914,0,0,1,32.9,30.155Z",
    fill: "#f9c795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.384,35.263a1.786,1.786,0,0,0-.539,1.288,1.833,1.833,0,0,0,1.828,1.828,1.828,1.828,0,1,0,0,3.655,1.828,1.828,0,0,0,0,3.655h.914a1.828,1.828,0,0,0-1.608,2.7l-.219.046H19.327a16.174,16.174,0,0,1-7.182-1.691l-1.325-.667A3.542,3.542,0,0,0,9.2,45.69H1.828A1.833,1.833,0,0,1,0,43.862V35.638A1.833,1.833,0,0,1,1.828,33.81h6.9a3.682,3.682,0,0,0,2.33-.841,16.053,16.053,0,0,1,10.289-3.728H26.5v5.483H24.672a1.786,1.786,0,0,0-1.288.539Z",
    fill: "#f9c795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.672,23.759h3.655V36.552H24.672Z",
    fill: "#cb8252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.328,48.431v2.741a1.828,1.828,0,1,1-3.655,0V48.431Z",
    fill: "#cb8252"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.724,
    height: 25.586,
    rx: 1.828,
    transform: "translate(9.138)",
    fill: "#f9eab0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.931,9.138a4.574,4.574,0,0,0-4.569-4.569H14.621A1.828,1.828,0,0,0,12.793,6.4V19.19a1.828,1.828,0,0,0,1.828,1.828h2.741a4.555,4.555,0,0,0,2.713-8.224A4.553,4.553,0,0,0,21.931,9.138ZM20.1,16.448a2.741,2.741,0,0,1-2.741,2.741H14.621V13.707h2.741A2.741,2.741,0,0,1,20.1,16.448Zm-2.741-4.569H14.621V6.4h2.741a2.741,2.741,0,0,1,0,5.483Z",
    fill: "#a56a43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.638,4.569H33.81A1.828,1.828,0,0,0,31.983,6.4V19.19a1.828,1.828,0,0,0,1.828,1.828h1.828a5.488,5.488,0,0,0,5.483-5.483V10.052A5.488,5.488,0,0,0,35.638,4.569Zm3.655,10.966a3.655,3.655,0,0,1-3.655,3.655H33.81V6.4h1.828a3.655,3.655,0,0,1,3.655,3.655Z",
    fill: "#a56a43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.241,6.4a.914.914,0,1,0,0-1.828H23.759a.914.914,0,1,0,0,1.828h1.828V19.19H23.759a.914.914,0,1,0,0,1.828h5.483a.914.914,0,1,0,0-1.828H27.414V6.4Z",
    fill: "#a56a43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.069,47.517a1.841,1.841,0,0,1-1.828,1.828H23.759a1.828,1.828,0,0,1-1.828-1.828,1.768,1.768,0,0,1,.055-.448,1.736,1.736,0,0,1,.484-.841,1.786,1.786,0,0,1,1.288-.539h5.483A1.828,1.828,0,0,1,31,47.06,1.534,1.534,0,0,1,31.069,47.517Z",
    fill: "#f9c795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.069,43.862a1.841,1.841,0,0,1-1.828,1.828h-6.4a1.833,1.833,0,0,1-1.828-1.828,1.534,1.534,0,0,1,.064-.457,1.731,1.731,0,0,1,.475-.832,1.786,1.786,0,0,1,1.288-.539h6.4A1.828,1.828,0,0,1,31,43.405,1.534,1.534,0,0,1,31.069,43.862Z",
    fill: "#f9c795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.069,40.207a1.841,1.841,0,0,1-1.828,1.828h-6.4a1.833,1.833,0,0,1-1.828-1.828,1.534,1.534,0,0,1,.064-.457,1.731,1.731,0,0,1,.475-.832,1.786,1.786,0,0,1,1.288-.539h6.4A1.828,1.828,0,0,1,31,39.75,1.534,1.534,0,0,1,31.069,40.207Z",
    fill: "#f9c795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.069,36.552a1.841,1.841,0,0,1-1.828,1.828h-6.4a1.833,1.833,0,0,1-1.828-1.828,1.534,1.534,0,0,1,.064-.457,1.731,1.731,0,0,1,.475-.832,1.786,1.786,0,0,1,1.288-.539h6.4A1.828,1.828,0,0,1,31,36.095,1.534,1.534,0,0,1,31.069,36.552Z",
    fill: "#f9c795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,47.06a1.731,1.731,0,0,1-.475.832,1.786,1.786,0,0,1-1.288.539H23.759a1.839,1.839,0,0,1-1.608-.959,3.091,3.091,0,0,1-.164-.4,1.736,1.736,0,0,1,.484-.841,1.786,1.786,0,0,1,1.288-.539h5.483A1.828,1.828,0,0,1,31,47.06Z",
    fill: "#fdd7ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,43.405a1.731,1.731,0,0,1-.475.832,1.786,1.786,0,0,1-1.288.539h-6.4a1.828,1.828,0,0,1-1.764-1.371,1.731,1.731,0,0,1,.475-.832,1.786,1.786,0,0,1,1.288-.539h6.4A1.828,1.828,0,0,1,31,43.405Z",
    fill: "#fdd7ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,39.75a1.731,1.731,0,0,1-.475.832,1.786,1.786,0,0,1-1.288.539h-6.4a1.828,1.828,0,0,1-1.764-1.371,1.731,1.731,0,0,1,.475-.832,1.786,1.786,0,0,1,1.288-.539h6.4A1.828,1.828,0,0,1,31,39.75Z",
    fill: "#fdd7ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,36.095a1.731,1.731,0,0,1-.475.832,1.786,1.786,0,0,1-1.288.539h-6.4a1.828,1.828,0,0,1-1.764-1.371,1.731,1.731,0,0,1,.475-.832,1.786,1.786,0,0,1,1.288-.539h6.4A1.828,1.828,0,0,1,31,36.095Z",
    fill: "#fdd7ad"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBid);
export default __webpack_public_path__ + "static/media/bid.6b2a30e9bad45eca188c84c44335cfd2.svg";
export { ForwardRef as ReactComponent };